import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { EddYesNo } from '@Pages/happyFlowPages/eddQuestions/consts';

export const InvestmentCustodialForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[24px] mt-[16px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_INVESTMENT_ADVICE}>
        {({ onChange, value }) => (
          <div className='flex flex-col gap-[16px]'>
            <Text.H9 className='text-text-main-primary'>
              {t('organic.investmentCustodial.investmentTitle')}
            </Text.H9>
            <div className='flex flex-col gap-2'>
              <CustomRadioButton
                label={t('organic.investmentCustodial.no')}
                value={EddYesNo.NO}
                inputId='investment-advice-no'
                onChange={onChange}
                checked={value === EddYesNo.NO}
                name={EddEmbeddedFields.EDD_INVESTMENT_ADVICE}
              />
              <CustomRadioButton
                label={t('organic.investmentCustodial.yes')}
                value={EddYesNo.YES}
                inputId='investment-advice-yes'
                onChange={onChange}
                checked={value === EddYesNo.YES}
                name={EddEmbeddedFields.EDD_INVESTMENT_ADVICE}
              />
            </div>
          </div>
        )}
      </ControllerWrapper>

      <ControllerWrapper name={EddEmbeddedFields.EDD_CUSTODIAL_SERVICES}>
        {({ onChange, value }) => (
          <div className='flex flex-col gap-[16px]'>
            <Text.H9 className='text-text-main-primary'>
              {t('organic.investmentCustodial.custodialTitle')}
            </Text.H9>
            <div className='flex flex-col gap-2'>
              <CustomRadioButton
                label={t('organic.investmentCustodial.no')}
                value={EddYesNo.NO}
                inputId='custodial-services-no'
                onChange={onChange}
                checked={value === EddYesNo.NO}
                name={EddEmbeddedFields.EDD_CUSTODIAL_SERVICES}
              />
              <CustomRadioButton
                label={t('organic.investmentCustodial.yes')}
                value={EddYesNo.YES}
                inputId='custodial-services-yes'
                onChange={onChange}
                checked={value === EddYesNo.YES}
                name={EddEmbeddedFields.EDD_CUSTODIAL_SERVICES}
              />
            </div>
          </div>
        )}
      </ControllerWrapper>
    </div>
  );
};
